import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import type { CashBranch } from './cashdeskApi'

interface CashBranchSelectProps {
  branches: readonly CashBranch[]
  value?: string | null
  onChange?: (value: string | null) => void
  loading?: boolean
  disabled?: boolean
  allowClear?: boolean
  placeholder?: string
  style?: React.CSSProperties
}

export function CashBranchSelect({
  branches,
  value,
  onChange,
  loading,
  disabled,
  allowClear,
  placeholder,
  style,
}: CashBranchSelectProps) {
  const { t } = useTranslation()
  return (
    <Select<string>
      value={value ?? undefined}
      onChange={(next) => onChange?.(next ?? null)}
      loading={loading ?? false}
      {...(disabled === undefined ? {} : { disabled })}
      allowClear={allowClear ?? false}
      showSearch
      optionFilterProp="label"
      placeholder={placeholder ?? t('cashdesk.branchPlaceholder')}
      style={{ minWidth: 220, ...style }}
      options={branches.map((branch) => ({
        value: branch.id,
        label: `${branch.name} (${branch.code})`,
      }))}
    />
  )
}
